var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.isLoading)?_c('Load'):_vm._e(),(_vm.order.data)?[_c('OrderDetailStudio7',{on:{"fetch":_vm.refetch}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }